"use strict";
// export type HRef = string
Object.defineProperty(exports, "__esModule", { value: true });
exports.IResourcesMap = void 0;
class IResourcesMap {
}
exports.IResourcesMap = IResourcesMap;
